import { action } from 'sky-engine/api/index'

import { CAL_DESKTOP_ELEMENT_MNG } from '@/api/apiModules'
/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function getDesktopElementList(params) {
  return action(CAL_DESKTOP_ELEMENT_MNG, 'list', params)
}
